/**
 * Copyright © 2026 Adnuntius AS.
 *
 * CDN asset upload admin list and editor.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';

import {AppSharedModule} from '../../common/app-shared.module';
import {AdminListModule} from '../../common/directives/admin-list.module';
import {CreativeAssetsModule} from '../../creative/creative-assets.module';
import {CdnUploadEditPageComponent} from './cdn-upload-edit-page.component';
import {CdnUploadListPageComponent} from './cdn-upload-list-page.component';
import {CdnUploadRoutePageComponent} from './cdn-upload-route-page.component';

const CDN_UPLOAD = [
  CdnUploadEditPageComponent,
  CdnUploadListPageComponent,
  CdnUploadRoutePageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    AdminListModule,
    CreativeAssetsModule
  ],
  declarations: CDN_UPLOAD,
  exports: CDN_UPLOAD
})
export class CdnUploadModule {
}
